export default __webpack_public_path__ + "static/media/type_ico.39f87a56.svg";